import React, { Component } from "react";
import { Col, Container, Row } from "reactstrap";

// Import Background Image
import Background from "../../assets/images/hero-1-bg-img.png";

class HomeSolution extends Component {
  render() {
    return (
      <React.Fragment>
        <section
          className="pt-5 pb-5 bg-light"
          style={{ backgroundImage: `url(${Background})` }}
          id="home-solution"
        >
          <Container>
            <Row className="justify-content-center">
              <Col lg={6}>
                <h2 className="service-title f-24">HOME SOLUTION</h2>
                <h3
                  className="hero-1-title fw-normal"
                  style={{ color: "#2077b8" }}
                >
                  Solar for Homes: Powering a Sustainable Future
                </h3>
                <p className="text-muted mb-2">
                  Transform your home into a hub of clean, renewable energy with
                  our top-tier solar installation services. At the heart of
                  India’s solar revolution, we provide tailored solutions
                  designed to save you money, reduce your carbon footprint, and
                  ensure reliable power for your household.
                </p>
                <div className="mt-5 mb-5 mb-lg-0">
                  <img
                    src={"/assets/home-solutions.png"}
                    alt="HOME SOLUTION"
                    className="img-fluid d-block mx-auto"
                    style={{ maxHeight: "360px" }}
                  />
                </div>
              </Col>
              <Col lg={6}>
                <div>
                  <h4>Why Go Solar with Us?</h4>
                  <ul>
                    <li>
                      Harness India’s Abundant Sunlight: Tap into the limitless
                      power of the sun to fuel your home, with the potential to
                      generate energy year-round.
                    </li>
                    <li>
                      Unbeatable Savings: Slash your electricity bills while
                      enjoying government subsidies and incentives that make
                      solar more affordable than ever.
                    </li>
                    <li>
                      Eco-Friendly Energy: Contribute to a cleaner planet by
                      reducing your reliance on fossil fuels and minimizing your
                      carbon footprint.
                    </li>
                    <li>
                      Custom Solutions: Whether you need on-grid, off-grid, or
                      hybrid systems, we’ve got the perfect solar solution to
                      match your energy needs.
                    </li>
                  </ul>
                </div>
                <div>
                  <h4>How We Make Solar Simple</h4>
                  <ul>
                    <li>
                      Free Consultation: Start with a no-obligation consultation
                      to evaluate your energy needs and site feasibility.
                    </li>
                    <li>
                      Expert Design: Our specialists craft a customized solar
                      solution tailored to your home and lifestyle.
                    </li>
                    <li>
                      Seamless Installation: Enjoy a hassle-free installation
                      process led by our experienced technicians.
                    </li>
                    <li>
                      Ongoing Support: We offer monitoring, maintenance, and
                      customer support to ensure your system runs at peak
                      performance.
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default HomeSolution;
